import {useNavigate, useParams} from "react-router";
import useSuggestionRepository from "../../../../repository/assignment/useSuggestionRepository";
import useInterventionRepository from "../../../../repository/b2c/useInterventionRepository";
import {useEffect, useRef} from "react";
import isNull from "../../../../mixin/isNull";
import Suggestion from "../../../../entity/assignment/Suggestion";
import route from "../../../../enum/route";
import Box from "@mui/material/Box";
import {Alert, CircularProgress, Paper} from "@mui/material";
import Page from "../../../../material/skeleton/Page";
import Header from "../../../../material/skeleton/Header";
import Menu from "../Menu";
import Body from "../../../../material/skeleton/Body";
import Typography from "@mui/material/Typography";
import {Info} from "@mui/icons-material";
import Accordion from "../../../../material/accordion/Accordion";
import AccordionConfig from "../../../../material/accordion/AccordionConfig";
import AccordionUnity from "../../../../material/accordion/AccordionUnity";
import Place from "../b2c/place/Place";
import Footer from "../../../../material/skeleton/Footer";
import Choice from "./choice/Choice";
import useOrderRepository from "../../../../repository/b2c/useOrderRepository";

export default function () {
    const navigate = useNavigate();
    const {token} = useParams();
    const suggestionRepository = useSuggestionRepository();
    const orderRepository = useOrderRepository();
    const interventionRepository = useInterventionRepository();
    /** @type Suggestion */
    const suggestion = suggestionRepository.findOneByToken(token).select();
    /** @type Order */
    const order = orderRepository.findOneById(suggestion?.getB2cOrderId()).select();
    const acceptedInterval = useRef();


    useEffect(() => {
        suggestionRepository.findOneByToken(token).exec();

        return () => clearInterval(acceptedInterval.current);
    }, []);

    useEffect(() => {
        if (isNull(suggestion) || suggestion?.getStatus() !== Suggestion.STATUS_ACCEPTED) return;

        orderRepository.findOneById(suggestion.getB2cOrderId()).exec();

        clearInterval(acceptedInterval.current);

        acceptedInterval.current = setInterval(retrieveIntervention, 1000);
    }, [JSON.stringify(suggestion)]);

    const retrieveIntervention = async () => {
        /** @type Intervention */
        const intervention = await interventionRepository.findOneBySuggestion(suggestion.getId()).exec();

        if (!isNull(intervention)) navigate(route.ARTISAN_B2C_INTERVENTION.replace(":token", intervention.getToken()));
    }

    if (isNull(suggestion)) {
        return (
            <Box display="flex" justifyContent="center" mt={20}>
                <CircularProgress/>
            </Box>
        )
    }

    if (suggestion.getStatus() !== Suggestion.STATUS_PROPOSED) {
        return (
            <Page>
                <Header>
                    <Menu/>
                </Header>
                <Body hasFooter={false}>
                    {
                        suggestion.getStatus() === Suggestion.STATUS_ACCEPTED
                            ? (
                                <>
                                    <Box mt={20} display="flex" justifyContent={"center"}>
                                        <CircularProgress/>
                                    </Box>
                                    <Box mt={5}>
                                        <Typography textAlign="center" fontSize={"small"}>
                                            Vous avez accepté ce dossier, vous allez être redirigé vers l'intervention ...
                                        </Typography>
                                    </Box>
                                </>
                            )
                            : null
                    }

                    {
                        suggestion.getStatus() === Suggestion.STATUS_REFUSED
                            ? (
                                <Box mt={15}>
                                    <Typography textAlign="center" variant="h6">
                                        Vous avez refusé cette intervention
                                    </Typography>
                                </Box>
                            )
                            : null
                    }

                    {
                        suggestion.getStatus() === Suggestion.STATUS_CLOSED
                            ? (
                                <Box mt={15}>
                                    <Typography textAlign="center" variant="h6">
                                        Cette proposition a expirée
                                    </Typography>
                                </Box>
                            )
                            : null
                    }
                </Body>
            </Page>
        )
    }

    return (
        <Page>
            <Header>
                <Menu/>
            </Header>
            <Body sx={{position: "relative"}}>
                <Box mt={2}>
                    <Paper elevation={3}>
                        <Box display="flex" alignItems={"center"} px={2} py={1}>
                            <Box display="flex" alignItems={"center"}>
                                <Info color={"warning"}/>
                            </Box>
                            <Box ml={1}>
                                <Typography display={"block"}>
                                    Merci de prendre contact avec le client sous 15 minutes
                                </Typography>
                            </Box>
                        </Box>
                    </Paper>
                </Box>

                <Box mt={2}>
                    <Paper elevation={3} data-test="notify-b2c">
                        <Box display="flex" alignItems={"center"} px={2} py={1}>
                            <Box display="flex" alignItems={"center"}>
                                <Info color={"warning"}/>
                            </Box>
                            <Box ml={1}>
                                <Typography display={"block"}>
                                    Il s'agit d'une mission&nbsp;
                                    <Typography display="inline" color="warning" fontWeight="bold">sans prise en
                                        charge (B2C)</Typography>. Une commission de 33 € H.T. ainsi que 20 % de votre
                                    facture vous seront retenus.
                                </Typography>
                            </Box>
                        </Box>
                    </Paper>
                </Box>

                <Box mt={2} data-test="alert-order-comment">
                    <Alert severity={"info"}>
                        Descriptif mission : {order?.getOrderComment()}
                    </Alert>
                </Box>

                <Box mt={2}>
                    <Accordion
                        accordionConfig={
                            new AccordionConfig()
                                .setOpenFirstByDefault(true)
                                .addAccordionUnity(
                                    new AccordionUnity()
                                        .setTitle("Lieu")
                                        .setComponent(<Place/>)
                                )
                        }
                    />
                </Box>

            </Body>
            <Footer>
                <Choice/>
            </Footer>
        </Page>
    );
}